import React from "react";
import LoadingAnime from "../../reusble_components/loadingAnime";

function JobInternshipShimmer() {
  return (
    <div>
      <div className="h-full flex flex-col bg-gray-50">
        <div className="top w-full hidden">
          <LoadingAnime
            useShadow={false}
            numBoxes={1}
            page={"JobInternship"}
            boxHeight="10rem"
            gridColumns="grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1"
            innerBoxes={[
              {
                width: "28%",
                height: "27%",
                color: "bg-gray-400",
                shape: "rectangle",
                top: "0%",
                left: "0%",
              },
              {
                width: "14%",
                height: "35%",
                color: "bg-gray-400",
                shape: "rectangle",
                top: "0%",
                right: "0%",
              },
              {
                width: "15%",
                height: "27%",
                color: "bg-gray-400",
                shape: "rectangle",
                top: "61%",
                left: "0%",
              },
            ]}
          />
        </div>
        {/* <div className="mid flex flex-nowrap overflow-x-auto gap-4"
           style={{
            scrollbarWidth: "none",
          }}>
            <LoadingAnime
              numBoxes={7}
              page={"Job-mid"}
              boxHeight="192px"
              gridColumns="grid grid-cols-1 sm:grid-cols-7 md:grid-cols-7 lg:grid-cols-7 xl:grid-cols-7"
              innerBoxes={[
                // Circle at the top left
                {
                  width: "4rem", // Circle size
                  height: "4rem",
                  color: "bg-gray-400",
                  shape: "circle",
                  top: "0rem",
                  left: "12%",
                },
                // First   rectangle below the circle for text placeholder
                {
                  width: "80%",
                  height: "12%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "4.5rem", // Adjust position below the circle
                  left: "0.4rem",
                },
                // Second rectangle for text placeholder
                {
                  width: "100%",
                  height: "12%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "6rem", // Adjust position below the first rectangle
                  left: "0rem",
                },
                // Large rectangle at the bottom right
                {
                  width: "80%",
                  height: "12%",
                  color: "bg-gray-400",
                  shape: "rectangle", // Align at the bottom right
                  bottom: "0.8rem",
                  left: "0.4rem",
                },
              ]}
            />
      
        </div> */}
        <div className="bottom w-full">
          <LoadingAnime
            page={"JobInternship"}
            numBoxes={9} // Correct usage of equal sign to pass a number// Use equal sign for strings
            gridColumns="grid-cols-1 md:grid-cols-3 lg:grid-cols-3" // Correct string prop passing
             // String prop
            innerBoxes={[
              //first text
              {
                width: "54%",
                height: "20%",
                color: "bg-gray-400",
                shape: "rectangle",
                top: "0rem",
                left: "0.3rem",
              },
              //salary
              {
                width: "40%",
                height: "15%",
                color: "bg-gray-400",
                shape: "rectangle",
                top: "2.7rem",
                left: "0.3rem",
              },
              {
                width: "40%",
                height: "15%",
                color: "bg-gray-400",
                shape: "rectangle",
                top: "4.5rem",
                left: "0.3rem",
              },
              {
                width: "40%",
                height: "15%",
                color: "bg-gray-400",
                shape: "rectangle",
                top: "6.2rem",
                left: "0.3rem",
              },
              {
                width: "40%",
                height: "15%",
                color: "bg-gray-400",
                shape: "rectangle",
                bottom: "0rem",
                left: "0.3rem",
              },
              {
                width: "20%",
                height: "20%",
                color: "bg-gray-400",
                shape: "rectangle",
                bottom: "-0.5rem",
                right: "0.3rem",
              },
              {
                width: "30%",
                height: "42%",
                color: "bg-gray-400",
                shape: "rectangle",
                top: "2.7rem",
                right: "0.3rem",
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}

export default JobInternshipShimmer;
